import { Navigate, Outlet, type To } from 'react-router-dom';

import { useAppData } from '@modules/_shared/providers/AppDataProvider';

export const AdminRoute: React.FC<{ redirectTo?: To }> = ({ redirectTo }) => {
  const { me } = useAppData();

  return me?.is_admin ? (
    <Outlet />
  ) : (
    <Navigate to={redirectTo ?? '/dashboard'} replace />
  );
};
